<template>
  <div width="235px" class="geo-filter">
    <v-expansion-panels v-model="expend">
      <v-expansion-panel @click="panel">
        <v-expansion-panel-header color="#00475A" hide-actions>
          {{ $t("message.page.findLocation", { value: "default" }) }}
        </v-expansion-panel-header>
        <v-expansion-panel-content color="#00475A">
          <v-autocomplete
            :items="this.items"
            item-text="agreement"
            item-value="agreement"
            @change="filterListByContrat"
            dense
            solo
            outlined
            background-color="#fff"
            color="#00475A"
            multiple
            v-model="payload.contrats"
            hide-details
            :label="$t('message.pageKm.contractnum', { value: 'default' })"
            class="mb-1"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.agreement }}</span>
              <span v-if="index === 1" class="grey--text caption">
                (+{{ payload.contrats.length - 1 }} )
              </span>
            </template>
          </v-autocomplete>
          <!--serials-->
          <v-autocomplete
            :items="this.serailList"
            @change="filterListBySerial"
            item-text="serial"
            item-value="serial"
            dense
            solo
            outlined
            background-color="#fff"
            color="#00475A"
            multiple
            v-model="payload.series"
            class="mb-1"
            hide-details
            :label="$t('message.pageKm.serial', { value: 'default' })"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.serial }}</span>
              <span v-if="index === 1" class="grey--text caption">
                (+{{ payload.series.length - 1 }} )
              </span>
            </template>
          </v-autocomplete>

          <!--status-->
          <v-select
            :items="this.statusList"
            @change="filterListByStatus"
            item-text="statutContractuel"
            item-value="statutContractuel"
            dense
            solo
            outlined
            background-color="#fff"
            color="#00475A"
            multiple
            hide-details
            class="mb-1"
            v-model="vstatus"
            :label="$t('message.page.contractStatus', { value: 'default' })"
          >
            <template v-slot:item="{ item }">
              {{
                $t(getLocale(item.statutContractuel), { value: "default" })
              }}
            </template>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{
                $t(getLocale(item.statutContractuel), { value: "default" })
              }}</span>
              <span v-if="index === 1" class="grey--text caption">
                (+{{ vstatus.length - 1 }} )
              </span>
            </template>
          </v-select>
          <!--locos-->
          <v-autocomplete
            :items="this.locoList"
            @change="emitData"
            item-text="loconum"
            item-value="loconum"
            dense
            solo
            outlined
            background-color="#fff"
            color="#00475A"
            hide-details
            multiple
            v-model="payload.locomotives"
            :label="$t('message.pageKm.loco', { value: 'default' })"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleLoc">
                <v-list-item-action>
                  <v-icon
                    :color="payload.locomotives > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("message.select", { value: "default" }) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>

            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.loconum }}</span>
              <span v-if="index === 1" class="grey--text caption">
                (+{{ payload.locomotives.length - 1 }} )
              </span>
            </template>
          </v-autocomplete>

          <div class="infoFilter mb-5">
            <i>{{ $t("message.page.filterMsg", { value: "default" }) }}</i>
          </div>

          <!--startdate-->
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :label="$t('message.page.startDate', { value: 'default' })"
                readonly
                :value="startDateDisp"
                v-on="on"
                outlined
                dense
                class="mb-1"
                hide-details
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDateVal"
              no-title
              @input="startDateMenu = false"
              @change="refreshDate"
            ></v-date-picker>
          </v-menu>
          <!--startdate-->
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :label="$t('message.page.endDate', { value: 'default' })"
                readonly
                :value="endDateDisp"
                v-on="on"
                outlined
                dense
                hide-details
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDateVal"
              no-title
              @input="endDateMenu = false"
              @change="refreshDate"
            ></v-date-picker>
          </v-menu>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-btn tile small color="#6DB7A2" style="width: 62px" @click="toggle">
        <v-icon color="#fff">{{ expendIcon }}</v-icon>
      </v-btn>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  firstDateOfCurrentMonth,
  currentDate,
  parseDate,
  formatDate,
} from "@/shared/DateHelper";
export default {
  watch: {
    getterCurrentClient: function () {
      this.loadLocos();
      this.initializeDates();
      this.initalizePayload();
      this.refreshDate();
    },
  },
  methods: {
    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    extractLoco(data) {
      let locos = [];
      var i;
      for (i = 0; i < data.length; i++) {
        locos.push(data[i].loconum);
      }
      return locos;
    },

    toggleLoc() {
      this.$nextTick(() => {
        if (this.selectAllLoc) {
          this.payload.locomotives = [];
        } else {
          this.payload.locomotives = this.extractLoco(this.locoList);
          this.emitData();
        }
      });
    },
    panel() {
      if (this.expend == 0) {
        this.expendIcon = "mdi-chevron-down";
      } else {
        this.expendIcon = "mdi-chevron-up";
      }
    },

    getLocale(value) {
      if (value == "Titulaire") {
        return "message.page.titular";
      }

      if (value == "Reserve") {
        return "message.page.reserve";
      }

      if (value == "Performance") {
        return "message.page.performance";
      }

      if (value == "Spot") {
        return "message.page.spot";
      }
    },

    toggle() {
      if (this.expend == 0) {
        this.expend = null;
        this.expendIcon = "mdi-chevron-down";
      } else {
        this.expend = 0;
        this.expendIcon = "mdi-chevron-up";
      }
    },

    async loadLocos() {
      let payload = {
        customer: this.getterCurrentClient,
        start: firstDateOfCurrentMonth(),
        end: currentDate(),
      };
      await this.actionGetLocos(payload);
      this.items = this.getterLocos;
      this.serailList = this.getterLocos;
      this.locoList = this.getterLocos;
      this.statusList = this.getterLocos;
    },

    filterListByContrat(filter) {
      if (filter == "") {
        this.locoList = this.items;
        this.statusList = this.items;
        this.serailList = this.items;
      } else {
        let filterList = this.items.filter(function (item) {
          return filter.find((filteritem) => filteritem == item.agreement);
        });
        this.locoList = filterList;
        this.statusList = filterList;
        this.serailList = filterList;
      }
      this.payload.locomotives = [];
      this.payload.series = [];
      this.vstatus = [];
      this.emitData();
    },

    filterListBySerial(filter) {
      if (filter == "") {
        this.locoList = this.items;
        this.statusList = this.items;
      } else {
        let filterList = this.items.filter(function (item) {
          return filter.find((filteritem) => filteritem == item.serial);
        });
        this.locoList = filterList;
        this.statusList = filterList;
      }
      this.payload.locomotives = [];
      this.vstatus = [];
      this.emitData();
    },

    filterListByStatus(filter) {
      let series = this.payload.series;
      let filterList1;
      if (series.length == 0) {
        filterList1 = this.items;
        this.payload.locomotives = [];
      } else {
        filterList1 = this.items.filter(function (item) {
          return series.find((filteritem) => filteritem == item.serial);
        });
      }

      if (filter == "") {
        this.locoList = filterList1;
      } else {
        let filterList = filterList1.filter(function (item) {
          return filter.find(
            (filteritem) => filteritem == item.statutContractuel
          );
        });
        this.locoList = filterList;
        this.payload.locomotives = this.extractLoco(this.locoList);
      }
      this.emitData();
    },

    initializeDates() {
      this.startDateVal = formatDate(firstDateOfCurrentMonth());
      this.endDateVal = formatDate(currentDate());
    },

    initalizePayload() {
      this.payload.startdate = firstDateOfCurrentMonth();
      this.payload.enddate = currentDate();
      this.payload.clients = [this.getterCurrentClient];
      this.payload.contrats = [];
      this.payload.series = [];
      this.payload.locomotives = [];
    },

    refreshDate() {
      this.payload.enddate = parseDate(this.endDateVal);
      this.payload.startdate = parseDate(this.startDateVal);
      this.emitData();
    },

    emitData() {
      this.$emit("filter", this.payload);
    },
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
    }),
    ...mapGetters("customer", {
      getterCustomer: "getCustomer",
      getterLocos: "getLocos",
    }),

    selectAllLoc() {
      if (this.payload.locomotives == null) return false;
      return this.locoList.length === this.payload.locomotives.length;
    },

    selectSomeLoc() {
      if (this.payload.locomotives == null) return false;
      return this.payload.locomotives.length > 0 && !this.selectAllLoc;
    },

    icon() {
      if (this.selectAllLoc) return "mdi-close-box";
      if (this.selectSomeLoc) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
  },
  name: "PortalGeoFilter",
  mounted() {
    this.loadLocos();
    this.initializeDates();
    this.initalizePayload();
  },
  data: () => ({
    items: [],
    expend: null,
    expendIcon: "mdi-chevron-down",
    serailList: [],
    locoList: [],
    statusList: [],
    vstatus: [],
    endDateVal: null,
    endDateMenu: false,
    startDateVal: null,
    startDateMenu: false,
    payload: {
      startdate: null,
      enddate: null,
      clients: null,
      contrats: null,
      series: null,
      locomotives: null,
    },
  }),
};
</script>


<style scoped>
.infoFilter {
  color: #fff;
  font-size: 12px;
}

.geo-filter {
  position: fixed;
  z-index: 1099;
  top: 250px;
  left: 309px;
  width: 235px;
}

.geo-filter > * {
  z-index: 1100;
}

button {
  color: #fff;
}
</style>